"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safePlus = exports.getPrecision = exports.base64Encode = exports.base64Decode = exports.addParamsToUrl = exports.omit = exports.includeIf = exports.delay = exports.nDaysAgo = exports.convertTimeStringToDateString = exports.numberFromString = exports.booleanFromString = void 0;
var moment_1 = __importDefault(require("moment"));
var objectConstructor = {}.constructor;
var booleanFromString = function (strBool, defaultTo) {
    if (!!strBool) {
        return strBool == "true";
    }
    if (!!defaultTo) {
        return defaultTo;
    }
    return false;
};
exports.booleanFromString = booleanFromString;
function numberFromString(strNum, defaultTo) {
    var convertedValue = Number(strNum);
    if (isNaN(convertedValue)) {
        return defaultTo;
    }
    return convertedValue;
}
exports.numberFromString = numberFromString;
var convertTimeStringToDateString = function (timeString) {
    if (!timeString) {
        return "";
    }
    return (0, moment_1.default)(timeString).format("MMM DD, YYYY");
};
exports.convertTimeStringToDateString = convertTimeStringToDateString;
var nDaysAgo = function (numDays) {
    var today = new Date();
    return new Date(today.getTime() - numDays * 24 * 60 * 60 * 1000);
};
exports.nDaysAgo = nDaysAgo;
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
exports.delay = delay;
function includeIf(condition, value) {
    if (condition) {
        return value;
    }
    if (Array.isArray(value)) {
        return [];
    }
    return {};
}
exports.includeIf = includeIf;
function omit(object, deleteKeys) {
    if (object.constructor !== objectConstructor)
        return object;
    if (!Array.isArray(deleteKeys))
        return object;
    var copyObject = JSON.parse(JSON.stringify(object));
    deleteKeys.forEach(function (key) { return delete copyObject[key]; });
    return copyObject;
}
exports.omit = omit;
var addParamsToUrl = function (baseUrl, params) {
    var url = new URL(baseUrl);
    url = Object.keys(params).reduce(function (urlWithParams, paramKey) {
        urlWithParams.searchParams.append(paramKey, params[paramKey]);
        return urlWithParams;
    }, url);
    return url.href;
};
exports.addParamsToUrl = addParamsToUrl;
var base64Decode = function (base64Encoded) {
    try {
        var decoded = Buffer.from(base64Encoded, "base64");
        return JSON.parse(decoded.toString("ascii"));
    }
    catch (_a) {
        return "malformed - ".concat(base64Encoded);
    }
};
exports.base64Decode = base64Decode;
var base64Encode = function (text) {
    return Buffer.from(text).toString("base64");
};
exports.base64Encode = base64Encode;
function getPrecision(a) {
    var e = 1;
    while (Math.round(a * e) / e !== a)
        e *= 10;
    return Math.log(e) / Math.LN10;
}
exports.getPrecision = getPrecision;
var MAX_PRECISION = 4;
var safePlus = function (a, b, precision) {
    var precisionA = getPrecision(a);
    var precisionB = getPrecision(b);
    if (precisionA === 0 || precisionB === 0)
        return a + b;
    var decimalPrecision = Math.min(Math.max(precisionA, precisionB), precision !== null && precision !== void 0 ? precision : MAX_PRECISION);
    return Number((a + b).toFixed(decimalPrecision));
};
exports.safePlus = safePlus;
